export const generalHobbyOptions = [
  { label: "Reading" },
  { label: "Traveling" },
  { label: "Music" },
  { label: "Sports" },
  { label: "Art & Craft" },
  { label: "Cooking" },
  { label: "Meditation" },
  { label: "Gardening" },
  { label: "Photography" },
  { label: "Contributing to Social Activities" },
];

export const spiritualActivityOptions = [
  { label: "Intersted / Participating in Aradhana" },
  { label: "Intersted / Participating in Patha" },
  { label: "Intersted / Participating in Pravachana" },
  { label: "Intersted / Participating in Bhajane" },
  { label: "Intersted / Practicing Puja" },
  { label: "Intersted / Practicing Sandhyavandane" },
  { label: "Intersted / Practicing Tulasi Puje" },
  { label: "Menstruration Practices" },
  { label: "Observing Chaturmasya" },
  { label: "Observing Ekadashi" },
];

export const hobbyOptions = [
  ...generalHobbyOptions,
  ...spiritualActivityOptions,
];

export default hobbyOptions;